import React from "react";
import BrandFilter from "../../common/BrandFilter";
import useBrandFilter from "../../../hooks/useBrandFilter";

/**
 * The brand chip on the Analytics landings. These tiles come from builders that
 * don't split by brand yet (FieldRoutes rollups, revenue summaries), so the chip
 * does NOT pretend to filter them: choosing a brand says so and points to the
 * Owner scorecard, which does split. The choice is shared with every other page.
 */
export default function AnalyticsBrandFilter() {
  const { brands, show, brand, setBrand } = useBrandFilter();
  return (
    <BrandFilter
      show={show}
      brands={brands}
      value={brand}
      onChange={setBrand}
      note="These tiles count every brand. The Owner scorecard, Leads and Customers are split by brand."
    />
  );
}
